import { render, staticRenderFns } from "./MainModal.vue?vue&type=template&id=d5e4e468&scoped=true"
import script from "./MainModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MainModal.vue?vue&type=style&index=0&id=d5e4e468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e4e468",
  null
  
)

export default component.exports